// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__12UQC","exampleContainer":"style_exampleContainer__21mMW"};